/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateSalesInvoiceOrderNumberDto
 */
export interface CreateUpdateSalesInvoiceOrderNumberDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceOrderNumberDto
     */
    orderNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSalesInvoiceOrderNumberDto
     */
    orderDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSalesInvoiceOrderNumberDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the CreateUpdateSalesInvoiceOrderNumberDto interface.
 */
export function instanceOfCreateUpdateSalesInvoiceOrderNumberDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "orderNumber" in value;
    isInstance = isInstance && "orderDate" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function CreateUpdateSalesInvoiceOrderNumberDtoFromJSON(json: any): CreateUpdateSalesInvoiceOrderNumberDto {
    return CreateUpdateSalesInvoiceOrderNumberDtoFromJSONTyped(json, false);
}

export function CreateUpdateSalesInvoiceOrderNumberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateSalesInvoiceOrderNumberDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderNumber': json['orderNumber'],
        'orderDate': (json['orderDate'] === null ? null : new Date(json['orderDate'])),
        'active': json['active'],
    };
}

export function CreateUpdateSalesInvoiceOrderNumberDtoToJSON(value?: CreateUpdateSalesInvoiceOrderNumberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderNumber': value.orderNumber,
        'orderDate': (value.orderDate === null ? null : value.orderDate.toISOString()),
        'active': value.active,
    };
}

